import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Grid, GridItem, LoadingIndicator, SearchInput, ThemeContext } from '@forma/forma-ui-kit';
import classNames from 'classnames';
import { queries } from '@/helpers/api';
import { getListTemplatesAndFoldersWithPath } from '@/helpers/workWithTreeFolders';
import Element from '../parts/Element';

import styles from './search-block.module.css';

const SearchBlock = ({ className }) => {
  const { t } = useTranslation();
  const initialStateSearch = { folders: [], templates: [] };
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [dataFoldersAndTemplates, setDataFoldersAndTemplates] = useState(null);
  const [foldersSearch, setFoldersSearch] = useState(initialStateSearch);
  const { viewport } = useContext(ThemeContext);
  const isPhone = viewport === 'phone';

  const rootClasses = classNames(
    styles.wrapper,
    inputValue && styles.wrapperActive,
    className
  );

  const classesWrapperResult = classNames(
    styles.result,
    'styled-scrollbar',
    inputValue && styles.openResult
  );

  const getDataFromApi = async () => {
    const templatesAndFolders = await queries.getSharedTemplates();
    const allTemplatesAndFoldersWithPath = getListTemplatesAndFoldersWithPath(
      templatesAndFolders.folders,
      templatesAndFolders.templates
    );
    return allTemplatesAndFoldersWithPath;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getDataFromApi();
        setDataFoldersAndTemplates(data);
      } catch {
        // eslint-disable-next-line
        console.error('Error with get data from server');
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    sendRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  const sendRequest = async () => {
    if (
      !inputValue
      || !dataFoldersAndTemplates
      || !dataFoldersAndTemplates.folders.length
      || !dataFoldersAndTemplates.templates.length
    ) return;
    setIsLoading(() => true);
    try {
      const inputValueForSearch = inputValue.toLowerCase();
      const folders = dataFoldersAndTemplates.folders.filter(
        (elem) =>
          elem.name.toLowerCase().includes(inputValueForSearch) ||
          elem.keyWords.some((keyword) =>
            keyword.toLowerCase().includes(inputValueForSearch)
          )
      );
      const templates = dataFoldersAndTemplates.templates.filter(
        (elem) =>
          elem.name.toLowerCase().includes(inputValueForSearch) ||
          elem.keyWords.some((keyword) =>
            keyword.toLowerCase().includes(inputValueForSearch)
          )
      );
      setFoldersSearch(() => ({ folders, templates }));
    } catch (error) {
      // eslint-disable-next-line
      console.error('Ошибка при получении данных', error);
    } finally {
      setIsLoading(() => false);
    }
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const handleBacklightFunc = (result, text) => {
    if (!text) {
      return result;
    }
    text = text.trim();
    const escapedText = escapeRegExp(text);
    const parts = result.split(new RegExp(`(${escapedText})`, 'gi'));

    return parts.map((part, index) =>
      part.toLowerCase() === text.toLowerCase() ? (
        <span key={index} className={styles.partsWord}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return (
    <div className={rootClasses} id="search">
      <div className={styles.root}>
        <SearchInput onSearch={setInputValue} placeholder={isPhone ? t('search_text') : t('search_input_fill_text')} />
      </div>
      <div className={classesWrapperResult}>
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <div>
            {(!foldersSearch.templates.length && !foldersSearch.folders.length) && (
              <div className={styles.text}>{t('nothing_not_found')}</div>
            )}
            {!!foldersSearch.folders.length && (
              <div className={styles.outerResultBlock}>
                <div className={styles.subtitle}>{t('categories')}</div>
                <Grid columns={3} className={styles.innerResultBlock} responsive={{ tabletS: 1, phone: 1 }}>
                  {foldersSearch.folders.map((elem) => (
                    <GridItem key={elem.id}>
                      <Element
                        type="folder"
                        {...elem}
                        href={`/templates/${elem.path}`}
                      >
                        {handleBacklightFunc(
                          elem.name,
                          inputValue.toString()
                        )}
                      </Element>
                    </GridItem>
                  ))}
                </Grid>
              </div>
            )}
            {!!foldersSearch.templates.length && (
              <div className={styles.outerResultBlock}>
                <div className={styles.subtitle}>{t('templates')}</div>
                <Grid columns={3} className={styles.innerResultBlock} responsive={{ tabletS: 1, phone: 1 }}>
                  {foldersSearch.templates.map((elem) => (
                    <GridItem key={elem.id}>
                      <Element
                        key={elem.id}
                        type="doc"
                        href={`/templates/${elem.path}`}
                        {...elem}
                      >
                        {handleBacklightFunc(elem.name, inputValue)}
                      </Element>
                    </GridItem>
                  ))}
                </Grid>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBlock;
